import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ServiceDetailsMain from '../Components/Services/ServiceDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import posts from '../Components/data/data-service.json'

function ServiceDetails() {
    const { slug } = useParams();
    const isLegacyNumericRoute = typeof slug === 'string' && /^\d+$/.test(slug);
    const legacyService = isLegacyNumericRoute
        ? posts.find((post) => post.id === parseInt(slug, 10))
        : null;

    if (legacyService) {
        return <Navigate to={`/service/${legacyService.slug}`} replace />;
    }

    const selectedService = slug ? posts.find((post) => post.slug === slug) : null;

    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title={selectedService ? selectedService.title : 'Service Details'}
            />
            <ServiceDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default ServiceDetails
